import { createApp } from 'vue'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import GoogleTranslateSelect from '@google-translate-select/vue3'
import 'vue-tel-input/vue-tel-input.css'
import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'
import GlobalError from './components/GlobalError.vue'

const app = createApp(App)
app.use(stores)
app.use(router)
app.use(GoogleTranslateSelect)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.component('GlobalError', GlobalError)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
